import { render } from "./AIMLItsTrustComp.vue?vue&type=template&id=6e9a470b&scoped=true"
import script from "./AIMLItsTrustComp.vue?vue&type=script&lang=js"
export * from "./AIMLItsTrustComp.vue?vue&type=script&lang=js"

import "./AIMLItsTrustComp.vue?vue&type=style&index=0&id=6e9a470b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9a470b"]])

export default __exports__